import { createApp } from 'vue'
import '@/darkMode/theme'
import '@/assets/style/reset.less' // 初始化样式
import 'animate.css' // animate.css
import '@/assets/style/common.less'
import App from './App.vue'
import router from './router' // 路由
import store from './store' // store
import './permission' // 路由权限
// import '@/utils/consoleGuard'
import mixin from './mixins/index' // 全局混入
import * as filters from './filters' // 全局过滤
import VueClipBoard from 'vue-clipboard2' // 文本粘贴插件
import elementConfig from '@/utils/elementUiConfig' // element-ui组件引入
import to from '@/utils/await-to-js' // 优化async-await
import axios from 'axios'
import directives from '@/directives' // 全局指令引入
import '@/assets/style/element-ui.css' // 自定义element-ui样式，按需引入组件需要放在按需组件引入下方方可生效
import '@/extend/myElement.less'
import 'element-plus/dist/index.css'
import '@/assets/style/smcp.css' // 验证码滑块样式
import EventBus from '@/utils/event.js'

import Logo from '@/components/v2/Logo.vue'
import Policy from '@/components/v2/policy.vue'

import { getFrom } from './utils/logTrack'
import { getUserId } from './utils/auth'
// sentry开始
import * as Sentry from '@sentry/vue'
import { performanceCapture } from '@/configure/performance/index'
import '@/darkMode/point' // 增加暗黑模式埋点

// 注册qiankun微前端
// import './qiankun'

const app = createApp(App)

window.VueInstance = app

// const $bus = new EventBus()
// 挂载
// 1.使用provide提供
// app.provide('$bus', $bus)
// 2.挂载到this上
app.config.globalProperties.$bus = EventBus
// 生产环境 随机生成1-10数字 等于5的时候进行sentry初始化 上报错误日志
if (Sentry && process.env.VUE_APP_SENTRY_ENV) {
  Sentry.init({
    app,
    dsn: 'https://29a9d86d8e916ec75e6523603119745c@test-sentry.chatglm.cn/9', // 推送地址
    release: window.page_version || '1.0.0', // 对应的版本
    environment: process.env.VUE_APP_SENTRY_ENV, // 对应环境
    integrations: [
      new Sentry.Integrations.Breadcrumbs({
        console: false // 去掉console
      }),
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      })
      // new Sentry.Replay() // 回放
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0 // 采样率
    // Session Replay
    // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    // replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}

// sentry结束
console.log(process.env.VUE_APP_SENTRY_ENV, 'VUE_APP_SENTRY_ENV')
// 神策埋点开始
var sensors = window.sensorsDataAnalytic201505
window.sensors = sensors
if (window.sensors) {
  sensors.init({
    server_url:
      '//zhipuaishengchan.datasink.sensorsdata.cn/sa?project=production&token=12da2141032f57b4',
    heatmap: {
      // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      //
      collect_tags: {
        div: true,
        p: true,
        h1: true,
        h2: true,
        h3: true,
        h4: true,
        h5: true,
        h6: true,
        img: true,
        svg: true,
        span: true,
        th: true,
        td: true,
        tr: true
      },
      // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'default',
      get_vtrack_config: true
    },
    is_track_single_page: true,
    use_client_time: true,
    send_type: 'beacon',
    show_log: false,
    preset_properties: {
      latest_wx_ad_click_id: true
    }
  })
  sensors.registerPage({
    platform_name: 'TOC_Web',
    DownloadChannel: getFrom()
  })
  sensors.use('PageLeave', {
    custom_props: {
      prop1: 'value1'
    },
    heartbeat_interval_time: 5,
    max_duration: 5 * 24 * 60 * 60,
    isCollectUrl: function (url) {
      // url 为要采集页面浏览时长的页面地址。
      return true // 采集
      // return false; // 不采集
    }
  })
  sensors.use('PageLoad', { max_duration: 120 })
  // 初始化渠道插件
  sensors.use('SensorsChannel')
  // SA 云版用户需要增加如下代码
  sensors.use('SatPropsPatch')
  sensors.quick('autoTrack')
  sensors.quick('isReady', function () {
    store.commit('Detail/SET_ANONYMOUS_ID', sensors.quick('getAnonymousID'))
  })
  if (getUserId()) {
    console.log(getUserId(), 'getUserId()getUserId()getUserId()')
    sensors.login(getUserId())
  }
}
// 神策埋点结束
// import VueAnalytics from 'vue-analytics'

performanceCapture()

// import workbox from './registerServiceWorker' // service worker
// 全局引入workbox
// Vue.prototype.$workbox = workbox
// 全局引入axios
app.component('Logo', Logo)
app.component('Policy', Policy)
app.config.globalProperties.$axios = axios
// 优雅处理async await
app.config.globalProperties.awaitTo = to
// 按需引入element-ui 组件
elementConfig(app)
// 文本粘贴
app.use(VueClipBoard)
// 全局混入
app.mixin(mixin)
// 全局过滤
app.config.globalProperties.$filters = {}
Object.keys(filters).forEach(key => {
  app.config.globalProperties.$filters[key] = filters[key]
})
// 全局指令
app.use(directives)

// Configuration VueAnalytics
// Vue.use(VueAnalytics, {
//   id: 'G-PMD05MS2V9'
// })
app.config.globalProperties.routerAppend = (path, pathToAppend) => {
  return path + (path.endsWith('/') ? '' : '/') + pathToAppend
}
const vm = app.use(router).use(store).mount('#app')
export default vm
